<fieldset *ngIf="(canAssignUserManagementPermissions$ | async)">
    <legend>Admin company user management</legend>

    <div *ngIf="companyList | async as companies">
        <dx-select-box [searchEnabled]="true" [items]="companies" displayExpr="fullIdentifier" valueExpr="id" (onValueChanged)="selectCompany($event)"></dx-select-box>
    </div>


    <dx-data-grid #usercompanygrid
    [dataSource]="adminDataSource$.asObservable() | async"
    [showBorders]="true">
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-editing
    mode="cell"
    [allowUpdating]="true"
    [allowDeleting]="false"
    [confirmDelete]="false">
</dxo-editing>
    <dxo-selection
    mode="none"> <!-- "multiple" | "none" -->
</dxo-selection>
    <dxi-column dataField="isOwner" cellTemplate="cellTemplate" [width]="25" caption="" alignment='center' allowFiltering='false' repaintChangesOnly='true'></dxi-column>
    <div *dxTemplate="let cell of 'cellTemplate'">
        <div [ngSwitch]="cell.value">
            <i *ngSwitchCase='false' class="far fa-user" title="User"></i>
            <i *ngSwitchCase='true' class="far fa-user-crown" title="Owner"></i>
        </div>
        <!-- <div style="color:blue">{{cell.text}}</div> -->
    </div>
    <dxi-column dataField="firstName">
    </dxi-column>
    <dxi-column dataField="lastName">
    </dxi-column>
    <dxi-column dataField="email">
    </dxi-column>
    <dxi-column dataField="canCreateLinks"
    [setCellValue]="setCellValueCreate">
    </dxi-column>
    <dxi-column dataField="canEditLinks"
        [setCellValue]="setCellValueEdit">
    </dxi-column>
    <dxi-column dataField="canRunLinks"
        [setCellValue]="setCellValueRun">
    </dxi-column>
    <dxi-column dataField="canEnableOrDisableLinks"
         [setCellValue]="setCellValueEnableOrDisable">
    </dxi-column>
    <dxi-column dataField="canDeleteLinks"
        [setCellValue]="setCellValueDelete">
    </dxi-column>

</dx-data-grid>
</fieldset>
